import React from "react";

// Components
import {FormPageLayout} from "../../components/layout/FormPageLayout";
import {VaccineListFeature} from "../../features/vaccineList";
import {NAVIGATION_BAR_HEIGHT} from "../../designSystem/tokens/spacing";

const VaccineListPage = () => (
  <FormPageLayout
    height={NAVIGATION_BAR_HEIGHT.EMPTY}
    body={<VaccineListFeature />}
  />
)
export default VaccineListPage;
